import { useQuery } from '@tanstack/react-query'

import { api } from '@/lib/api'
import type { PaginationQuery } from '@/types/api'

export function useMonitors(query: PaginationQuery & { projectId?: string } = {}) {
  return useQuery({
    queryKey: ['monitors', query],
    queryFn: () => api.monitors.list(query),
    select: (res) => res.data,
  })
}
